import styled from 'styled-components';

export const ButtonWrapper = styled.button`
  background-color: transparent;
  border: none;
  padding: 0;
  box-shadow: none;
  margin: 0;
  display: flex;
  align-items: center;
  :hover, :focus {
    background-color: transparent !important;
    border: none;
    box-shadow: none;
  }
`;



// WEBPACK FOOTER //
// ./src/components/DateTimeButton/styles.js